(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["installments"] && !Shopify.designMode) return;
  try {
    class RkInstallmentsBlock extends HTMLElement {
    connectedCallback() {
      this._abort = new AbortController();
      const signal = this._abort.signal;

      // 1) Eventos DOM comuns entre temas
      ['variant:update', 'variant:change', 'on:variant:update'].forEach((name) => {
        document.addEventListener(name, (e) => {
          const v = e.detail?.resource || e.detail?.variant || e.detail;
          if (v && v.id) this.showVariant(v.id);
        }, { signal });
      });

      // 2) Fallback universal: observar o input[name="id"] do product form mais próximo
      const form = this.closest('section, product-card, .product, main')
        ?.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')
        || document.querySelector('form[action*="/cart/add"]');

      const input = form?.querySelector('input[name="id"], select[name="id"]');
      if (input) {
        this._observer = new MutationObserver(() => this.showVariant(input.value));
        this._observer.observe(input, { attributes: true, attributeFilter: ['value'] });
        // alguns temas atualizam .value sem mexer no atributo, então escuta change também
        form.addEventListener('change', () => {
          requestAnimationFrame(() => this.showVariant(input.value));
        }, { signal });
      }

      // 3) Fallback extra: mudança na URL (?variant=...) sem reload
      window.addEventListener('popstate', () => this.syncFromUrl(), { signal });
      const origPushState = history.pushState.bind(history);
      const origReplaceState = history.replaceState.bind(history);
      this._restoreHistory = () => {
        history.pushState = origPushState;
        history.replaceState = origReplaceState;
      };
      history.pushState = (...args) => {
        origPushState(...args);
        this.syncFromUrl();
      };
      history.replaceState = (...args) => {
        origReplaceState(...args);
        this.syncFromUrl();
      };
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this._restoreHistory?.();
    }

    syncFromUrl() {
      const variantId = new URLSearchParams(window.location.search).get('variant');
      if (variantId) this.showVariant(variantId);
    }

    showVariant(variantId) {
      if (!variantId) return;
      const target = this.querySelector('[data-variant-id="' + variantId + '"]');
      if (!target) return; // variante de outro produto — ignora
      this.querySelectorAll('[data-variant-id]').forEach((el) => {
        el.hidden = el !== target;
      });
    }
  }

  if (!customElements.get('rk-installments-block')) {
    customElements.define('rk-installments-block', RkInstallmentsBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pix-price"] && !Shopify.designMode) return;
  try {
    class RkPixPriceBlock extends HTMLElement {
    connectedCallback() {
      this._abort = new AbortController();
      const signal = this._abort.signal;

      // 1) Eventos DOM comuns entre temas
      ['variant:update', 'variant:change', 'on:variant:update'].forEach((name) => {
        document.addEventListener(name, (e) => {
          const v = e.detail?.resource || e.detail?.variant || e.detail;
          if (v && v.id) this.showVariant(v.id);
        }, { signal });
      });

      // 2) Fallback universal: observar o input[name="id"] do product form mais próximo
      const form = this.closest('section, product-card, .product, main')
        ?.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')
        || document.querySelector('form[action*="/cart/add"]');

      const input = form?.querySelector('input[name="id"], select[name="id"]');
      if (input) {
        this._observer = new MutationObserver(() => this.showVariant(input.value));
        this._observer.observe(input, { attributes: true, attributeFilter: ['value'] });
        // alguns temas atualizam .value sem mexer no atributo, então escuta change também
        form.addEventListener('change', () => {
          requestAnimationFrame(() => this.showVariant(input.value));
        }, { signal });
      }

      // 3) Fallback extra: mudança na URL (?variant=...) sem reload
      window.addEventListener('popstate', () => this.syncFromUrl(), { signal });
      const origPushState = history.pushState.bind(history);
      const origReplaceState = history.replaceState.bind(history);
      this._restoreHistory = () => {
        history.pushState = origPushState;
        history.replaceState = origReplaceState;
      };
      history.pushState = (...args) => {
        origPushState(...args);
        this.syncFromUrl();
      };
      history.replaceState = (...args) => {
        origReplaceState(...args);
        this.syncFromUrl();
      };
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this._restoreHistory?.();
    }

    syncFromUrl() {
      const variantId = new URLSearchParams(window.location.search).get('variant');
      if (variantId) this.showVariant(variantId);
    }

    showVariant(variantId) {
      if (!variantId) return;
      const target = this.querySelector('[data-variant-id="' + variantId + '"]');
      if (!target) return; // variante de outro produto — ignora
      this.querySelectorAll('[data-variant-id]').forEach((el) => {
        el.hidden = el !== target;
      });
    }
  }

  if (!customElements.get('rk-pix-price-block')) {
    customElements.define('rk-pix-price-block', RkPixPriceBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
